import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { AddEditModalGeneric } from '../../../ui/generics';
import { IStockTransfer } from '../core/interfaces/IStockTransfer';
import { AddEditFormComponent } from '../add-edit-form/add-edit-form.component';
import { StockTransferStatusTypes } from '../core/enums';

@Component({
    selector: 'app-add-edit-modal',
    templateUrl: './add-edit-modal.component.html',
    styleUrls: ['./add-edit-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditModalComponent extends AddEditModalGeneric<IStockTransfer, AddEditFormComponent> implements OnInit {

  @Input() override triggerTitle = 'Neue Umlagerung erstellen';
  public readonly stockTransferStatusTypes = StockTransferStatusTypes;

  constructor(
    protected cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  override rebuildTitle(): void {
    if (this.isNew) {
      this.title = 'Neue Umlagerung erstellen';
      return;
    }
    this.title = this.object?.id != null
      ? `Umlagerung: #${this.object.id}`
      : 'Umlagerung';
  }
}
